export default __webpack_public_path__ + "static/media/MontserratAlternates-Regular.a14e717f.ttf";